import { FC, useEffect, useState } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import { getIsLogin } from 'lowcode/utils/getIsLogin';
import Banner from '../Common/Banner';
import Refer from '../Common/Refer';
import Terms from '../Common/Terms';
import Subscribe from '../Common/SubscribeReceive';
import ProductGallery from '../Share/ProductGallery';
import Rewards from './Rewards';
import Products from './Products';
// import Blogs from './Blogs';
import Benefits from './Benefits';
import JoinUs from './JoinUs';
import styled from './index.module.scss';
import CallToActionBanner from './CallToActionBanner';
import BenefitsNew from '@/components/EcoCredits/BenefitsNew';
import { useReferralDispatch, useReferralStore } from '@/components/Ambassador/ReferralProvider';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';
import { checkInviteCode } from '@/service/referral';
import { message } from '@/components/UI';
import { loginUser } from '@/utils/cookie';
import getLocal from '@/app/utils/getLocal';
// import MemberCard from '../Share/MemberCard';
// import { PlanType } from '../index.d';
import { getRewardRuleList, getRewardUserLevel } from '@/service/vip';
import { referalUrl, referraledUrl } from '@/components/Ambassador/constants';
import { useMonthlyDispatch } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import { signupCookie } from '@/utils/cookies/signupCookie';

const ReceiveCompoment: FC<{ isLogin: boolean }> = ({ isLogin }) => {
    const { useLang, useRouter, Link } = useGlobal();
    const router = useRouter();
    const { locale, pathname } = getLocal();
    const { t } = useLang('referral');
    const dispatch = useReferralDispatch();
    const monthlyDispatch = useMonthlyDispatch();
    const { inBlackList, referralInfo } = useReferralStore();
    // const isLogin = getIsLogin();
    const [codeState, setCodeState] = useState('0');
    const [userInfo, setUserInfo] = useState<any>({});
    const [show, setShow] = useState(false);
    const registerUrl = `/${locale}/register?inviteCode=${router.query.inviteCode}&redirect=${encodeURIComponent(`/${locale}${router.asPath}`)}`;

    const referralPath = referalUrl[locale] || referalUrl.us;
    const sharePath = referraledUrl[locale] || referraledUrl.us;

    const inviteErrorMap: Record<string, string> = {
        '2430': t('active_is_unstart'),
        '2431': t('active_is_ended'),
        '2438': t('invitation_expired'),
        '2439': t('invitation_ip'),
    };

    useEffect(() => {
        let pageType = '';
        const { inviteCode } = router.query;
        if (pathname === '/referral-rewards-delta-pro-3-portable-power-station') {
            pageType = 'dp3';
        }
        dispatch({ type: 'changePageUsingInfo', payload: pageType });
        dispatch({ type: 'getReferralInfoByInviteCode', payload: { locale, inviteCode } });
        checkCodeState();
        queryRewardUserLevel();
        setUserInfo(loginUser());
    }, []);

    // 检查 inviteCode 状态
    const checkCodeState = async () => {
        const { inviteCode } = router.query;
        // 如果没有邀请码 直接跳转分享页
        if (!inviteCode) {
            router.push(referralPath);
            return;
        }
        const fp = await FingerprintJS.load();
        const { visitorId } = await fp.get();
        const res = await checkInviteCode({ deviceId: visitorId, inviteCode }, locale);
        if (res.code !== '0') {
            setCodeState(res.code);
            inviteErrorMap[res.code] && message.error(inviteErrorMap[res.code]);
            if (res.code === '2439' || res.code === '2438') {
                router.push('/404');
            }
            if (res.code === '2440') {
                router.push(referralPath);
            }
        }
    };

    /**
     * 查询账户权益等级
     */
    const queryRewardUserLevel = async () => {
        const ruleRes = await getRewardRuleList(locale as string);
        if (ruleRes?.code !== '0') return;
        const plusMemberData = ruleRes.data.find((item) => item.level === 2);
        const memberData = ruleRes.data.find((item) => item.level === 1);
        const payload = {
            normalName: memberData?.name,
            plusName: plusMemberData?.name,
            minPoint: Number(plusMemberData?.minPoints),
        };

        if (isLogin) {
            const levelRes = await getRewardUserLevel(locale as string);
            if (levelRes?.code === '0' && levelRes.data) {
                const { level, validStartTime, validEndTime } = levelRes.data;
                const userLevelData = ruleRes.data.find((item) => item.level === level);

                Object.assign(payload, {
                    level,
                    validStartTime,
                    validEndTime,
                    name: userLevelData?.name || '',
                });
            }
        }
        monthlyDispatch({
            type: 'changeRewardUserLevel',
            payload,
        });
    };

    const toRegisterPage = (text: string) => {
        if (codeState === '2442') setShow(true);
        if (codeState !== '0') return;
        signupCookie?.({ sector_name: text, entry_position: 1 });
        location.href = registerUrl;
    };

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                `}
            </style>
            <div className={`${styled.receive_compoment}`}>
                <Banner
                    title={
                        isLogin
                            ? t.rich('banner.title2', {
                                  name: () => userInfo?.user?.name || userInfo?.user?.email,
                              })
                            : t('banner.title')
                    }
                    desc={
                        isLogin
                            ? t('banner.desc2')
                            : t.rich('banner.desc', {
                                  line1: (text: string) => (
                                      <a className="register_text" onClick={() => toRegisterPage(t('banner.title'))}>
                                          {text}
                                      </a>
                                  ),
                              })
                    }
                    isInner={false}
                >
                    {!isLogin && (
                        <Button className="refer-btn" onClick={() => toRegisterPage(t('banner.title'))} disabled={inBlackList}>
                            {t('banner.btn')}
                        </Button>
                    )}
                </Banner>
                <CallToActionBanner />
                {isLogin && <Rewards />}
                {/* {referralInfo?.planType === PlanType.CAMPAIGN && (
                            <MemberCard title={t('member.title')} subTitle={t('member.subTitle')} cta={t('member.button')} />
                        )} */}
                {/* <Blogs subScribe={() => subRef.current?.handleOpen()} /> */}
                {/* <Benefits /> */}
                <BenefitsNew />
                <Products />
                {isLogin && <Refer isShare={false} />}
                {isLogin && <JoinUs />}
                <Terms />
                <Subscribe isShare={true} />

                <EfModal
                    width="560"
                    visible={show}
                    open={show}
                    className={`${styled.no_active_modal}`}
                    centered={true}
                    getContainer={true}
                    onCancel={() => setShow(false)}
                >
                    <div className="content">
                        <h5 className="title">{t('invitation_tips_title')}</h5>
                        <p className="msg">{t('invitation_tips_cotent')}</p>
                        <div className="tools">
                            <Button className="btn later" onClick={() => setShow(false)}>
                                {t('invitation_tips_cancel')}
                            </Button>
                            <Link href={registerUrl}>
                                <Button className="btn">{t('invitation_tips_confirm')}</Button>
                            </Link>
                        </div>
                    </div>
                </EfModal>
            </div>
        </>
    );
};

export default ReceiveCompoment;
